import PropTypes from 'prop-types';

const MirrorIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g fill={fill} fillRule="evenodd">
        <path
          d="M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0zm.5 5C13.73 5 5 13.73 5 24.5S13.73 44 24.5 44 44 35.27 44 24.5 35.27 5 24.5 5z"
          fillRule="nonzero"
        />
        <path d="M13.713 23.277c-.95.95-.95 2.49 0 3.441l7.569 7.57a2.433 2.433 0 1 0 3.44-3.441l-7.569-7.57c-.95-.95-2.49-.95-3.44 0zm4.06-9.564c-.95.95-.95 2.49 0 3.44l13.074 13.075a2.433 2.433 0 1 0 3.44-3.44L21.213 13.712c-.95-.95-2.49-.95-3.44 0z" />
      </g>
    </svg>
  </div>
);

MirrorIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

MirrorIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default MirrorIcon;
